module.exports = __webpack_public_path__ + "img/Strip-Front-B9-Jd.6fae5d8c.png";